import { useTranslation } from "react-i18next";
import "./Map.css";

export enum LegendItem {
  Markers = "Markers",
  SCBOne = "SCBOne",
  Polygons = "Polygons",
}

interface BeaconMapLegendProps {
  legendItems: LegendItem[];
  style?: React.CSSProperties;
}

export function BeaconMapLegend({ style, legendItems }: BeaconMapLegendProps) {
  const { t } = useTranslation();

  const legendItemsMarkersBeacon = [
    { color: "green", text: t("beacon:on-accurate-position") },
    { color: "orange", text: t("beacon:on-inaccurate-position") },
    { color: "gray", text: t("beacon:off") },
  ];

  const legendItemsPolygons = [
    { color: "#5A85EF", text: t("translations:construction-project") },
    { color: "yellow", text: t("translations:construction-site") },
  ];

  const legendItemsMarkersSCBOne = [
    { color: "green", text: t("beacon:on-accurate-position") },
    { color: "orange", text: t("beacon:on-inaccurate-position") },
  ];

  return (
    <div
      className="beacon-map-info-button-popup"
      style={style ? style : { top: "0px", right: "35px" }}
    >
      {legendItems.includes(LegendItem.Markers) &&
        legendItemsMarkersBeacon.map((item, index) => (
          <p key={index}>
            <span style={{ color: item.color }}>●</span> {item.text}
          </p>
        ))}
      {legendItems.includes(LegendItem.Polygons) &&
        legendItemsPolygons.map((item, index) => (
          <p key={index}>
            <span style={{ color: item.color }}>●</span> {item.text}
          </p>
        ))}
      {legendItems.includes(LegendItem.SCBOne) &&
        legendItemsMarkersSCBOne.map((item, index) => (
          <p key={index}>
            <span style={{ color: item.color }}>●</span> {item.text}
          </p>
        ))}
    </div>
  );
}
